<template>
  <div
    v-if="visible"
    class="fixed left-0 right-0 top-[80px] z-[50] flex justify-center items-center px-16 pb-16 transition-all duration-1000 ease-linear"
    role="alert"
    aria-live="polite"
    aria-relevant="additions"
    aria-atomic="true"
    :aria-label="'Notification ' + message"
    tabindex="-1"
  >
    <div class="bg-grey-body text-white shadow-[0_2px_16px_0_rgb(0,0,0,0.2)] rounded-xl p-16 leading-normal flex items-center">
      <span>{{ message }}</span>
      <button aria-label="Close" class="modal-close ml-16" @click="hideNotification">
        <Close class="ml-8" color="white" :height="10" :width="10" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Close from '../../graphics/icons/CloseIconMini.vue';

export default {
  name: 'Notification',
  components: { Close },
  props: {
    triggerNotification: {
      default: false,
      type: Boolean,
    },
    message: {
      default: '',
      type: String,
    },
    customTimeout: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      visible: false,
      timeout: this.customTimeout,
      timeoutId: 0,
    };
  },
  watch: {
    triggerNotification() {
      this.visible = this.triggerNotification;
    },
    visible() {
      // clear previous timeout before new one
      window.clearTimeout(this.timeoutId);
      this.timeoutId = window.setTimeout(() => {
        this.hideNotification();
      }, this.timeout);
    },
  },
  mounted() {
    if (this.triggerNotification) this.visible = true;
  },
  methods: {
    hideNotification() {
      this.visible = false;
      this.$emit('toggleVisibility');
    },
  },
};
</script>
